import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useListLeagueHomeVenues } from "../api/LeagueVenueApiProvider";
import { useRetrieveUserLeagueMatchPermissions } from "../api/PermissionApiProvider";
import { useRetrieveLeagueMatch, useRetrieveSeason, useUpdateLeagueMatch, } from "../api/SeasonApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { NotFound } from "../nav/NotFound";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
import { LeagueMatchForm } from "./LeagueMatchForm";
export const UpdateLeagueMatch = () => {
    const { leagueId, seasonId, id } = useNumericParams();
    const navigate = useNavigate();
    const { data: permissions, isLoading: permissionsLoading, error: permissionsError, } = useRetrieveUserLeagueMatchPermissions({ leagueMatchId: id });
    const { canModify = false } = permissions || {};
    const { data: leagueMatch, isLoading: matchLoading, error: matchError, } = useRetrieveLeagueMatch({ id, enabled: canModify });
    const { data: season, isLoading: seasonLoading, error: seasonError, } = useRetrieveSeason({ id: seasonId, enabled: canModify });
    const { data: leagueVenues = [], isLoading: venuesLoading } = useListLeagueHomeVenues({ leagueId, enabled: canModify });
    const mutation = useUpdateLeagueMatch({
        onSuccess: (response) => {
            navigate(`/leagues/${leagueId}/seasons/${seasonId}?tab=fixtures&division=${response.data.division}`);
        },
    });
    const onSubmit = (data) => {
        mutation.mutate({ ...data, id: id });
    };
    if (permissionsLoading) {
        return _jsx(Loading, {});
    }
    if (permissionsError) {
        return _jsx(ErrorView, { error: permissionsError });
    }
    if (!canModify) {
        return _jsx(NotFound, {});
    }
    if (matchLoading || seasonLoading || venuesLoading) {
        return _jsx(Loading, {});
    }
    if (matchError || seasonError || !leagueMatch || !season) {
        return _jsx(ErrorView, { error: matchError || seasonError });
    }
    const divisions = season.divisions ?? [];
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: mutation.isError, message: "Failed to update match. Please try again." }), _jsx(Typography, { variant: "h6", children: _jsx("strong", { children: "Update League Match" }) }), _jsx(LeagueMatchForm, { divisions: divisions, leagueVenues: leagueVenues, onSubmit: onSubmit, leagueMatch: leagueMatch, isSubmitting: mutation.isLoading })] }));
};
